import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  aliasesTitle: {
    description: 'Product Details aliases Title',
    defaultMessage: 'Store Aliases',
    id: 'gvX7OK',
  },
  aliasesDefaultsSubHeader: {
    description: 'Product Details aliases Defaults SubHeader',
    defaultMessage: 'Store aliases will map future orders to this product for product details and reporting purposes.',
    id: 'j65UOo',
  },
  aliasHeaderSku: {
    description: 'Product Details alias Header Sku',
    defaultMessage: 'SKU',
    id: 'LhsvHz',
  },
  aliasHeaderStore: {
    description: 'Product Details alias Header Store',
    defaultMessage: 'Store',
    id: 'byuo8F',
  },
  anyStore: {
    description: 'Product Details Select a Store',
    defaultMessage: '(Any Store)',
    id: 'd4VBIG',
  },
  aliasesEmptyList: {
    description: 'Product Details aliases Empty List',
    defaultMessage: 'No store aliases have been created yet',
    id: '6OiGb/',
  },
  addAlias: {
    description: 'Alias Deletion Modal Add Alias',
    defaultMessage: 'Add Alias',
    id: 'OLC50Y',
  },
  aliasHeaderActions: {
    description: 'Product Details alias Header Actions column',
    defaultMessage: 'Actions',
    id: 'Nsnh9l',
  },
});
